/** Native app store listings (override via VITE_* on web if needed). */
export const MOBILE_APP_IOS_APP_ID = '6811803777'
export const MOBILE_APP_ANDROID_PACKAGE = 'com.redevicer.app'

export function appStoreUrl(appId = MOBILE_APP_IOS_APP_ID): string {
  return `https://apps.apple.com/app/id${appId}`
}

export function googlePlayStoreUrl(packageId = MOBILE_APP_ANDROID_PACKAGE, locale = 'en'): string {
  return `https://play.google.com/store/apps/details?id=${encodeURIComponent(packageId)}&hl=${encodeURIComponent(locale)}`
}
